import { AssureEditionEnum, HostingOptionEnum, LicenseStatus } from "@/app/api/battery-portal-api";
export class LicenseState {
    constructor() {
        this.appEdition = AssureEditionEnum.OnPremBasic;
        this.hostingOption = HostingOptionEnum.OnPrem;
        this.status = LicenseStatus.NotChecked;
        this.statusDisplayLabel = "Not Checked";
        this.isValid = false;
        this.isDefaultLicense = false;
        this.remainingDays = null;
        this.endDate = null;
        this.gracePeriodSecs = null;
    }
    reset() {
        this.appEdition = AssureEditionEnum.OnPremBasic;
        this.hostingOption = HostingOptionEnum.OnPrem;
        this.status = LicenseStatus.NotChecked;
        this.statusDisplayLabel = "Not Checked";
        this.isValid = false;
        this.isDefaultLicense = false;
        this.remainingDays = null;
        this.endDate = null;
        this.gracePeriodSecs = null;
    }
    // Helper methods for edition checks
    get isBasicEdition() {
        return this.appEdition === AssureEditionEnum.OnPremBasic;
    }
    get isStandardEdition() {
        return this.appEdition === AssureEditionEnum.OnPremStandard ||
            this.appEdition === AssureEditionEnum.PowershieldCloudStandard;
    }
    get isPremiumEdition() {
        return this.appEdition === AssureEditionEnum.OnPremPremium;
    }
    get isOnPrem() {
        return this.hostingOption === HostingOptionEnum.OnPrem;
    }
    get isCloud() {
        return this.hostingOption === HostingOptionEnum.PowershieldCloud;
    }
    get isClockTampered() {
        return this.status === LicenseStatus.ClockTampered;
    }
    get isActiveOrGracePeriod() {
        return !this.isClockTampered && (this.status === LicenseStatus.Valid ||
            this.status === LicenseStatus.InGracePeriod ||
            this.status === LicenseStatus.DefaultLicense);
    }
}
